import{Z as o,d as p}from"./p-CxmOppZx.js";const s=o;const t=p;export{s as ZprDropdownMenu,t as defineCustomElement};
//# sourceMappingURL=zpr-dropdown-menu.js.map